class ColorSelectorV2 extends HTMLElement {
  constructor() {
    super();
    this.attachShadow({ mode: 'open' });
    
    // Default values
    this.colors = [];
    this.selectedColor = '';
    this.label = this.getAttribute('label') || 'Color';
    
    // Parse colors from data attribute
    const colorsData = this.getAttribute('data-colors');
    if (colorsData) {
      try {
        this.colors = JSON.parse(colorsData);
        if (this.colors.length > 0) {
          this.selectedColor = this.colors[0].name;
        }
      } catch (e) {
        console.error('Error parsing colors data:', e);
      }
    }
    
    this.render();
    this.setupEventListeners();
  }
  
  static get observedAttributes() {
    return ['data-colors', 'label', 'selected-color'];
  }
  
  attributeChangedCallback(name, oldValue, newValue) {
    if (oldValue !== newValue) {
      switch (name) {
        case 'data-colors':
          try {
            this.colors = JSON.parse(newValue);
            if (this.colors.length > 0 && !this.selectedColor) {
              this.selectedColor = this.colors[0].name;
            }
            this.render();
            this.setupEventListeners();
          } catch (e) {
            console.error('Error parsing colors data:', e);
          }
          break;
        case 'label':
          this.label = newValue;
          this.render();
          this.setupEventListeners();
          break;
        case 'selected-color':
          this.selectedColor = newValue;
          this.updateSelectedColorDisplay();
          break;
      }
    }
  }
  
  render() {
    this.shadowRoot.innerHTML = `
      <style>
        .product-option {
          margin-bottom: 20px;
        }
        
        .option-label {
          display: block;
          margin-bottom: 10px;
          font-weight: 600;
        }
        
        .color-swatches {
          display: flex;
          gap: 10px;
        }
        
        .color-swatch {
          width: 36px;
          height: 36px;
          border-radius: 50%;
          border: 2px solid transparent;
          cursor: pointer;
          transition: all 0.2s ease;
        }
        
        .color-swatch:hover {
          transform: scale(1.1);
        }
        
        .color-swatch.active {
          border-color: #000;
          box-shadow: 0 0 0 2px rgba(0, 0, 0, 0.1);
        }
      </style>
      <div class="product-option">
        <label class="option-label">${this.label}: <span id="selected-color">${this.selectedColor}</span></label>
        <div class="color-swatches">
          ${this.colors.map(color => `
            <button 
              class="color-swatch${color.name === this.selectedColor ? ' active' : ''}" 
              style="background-color: ${color.color};" 
              data-color="${color.name}" 
              title="${color.name}"
            ></button>
          `).join('')}
        </div>
      </div>
    `;
  }
  
  setupEventListeners() {
    const colorSwatches = this.shadowRoot.querySelectorAll('.color-swatch');
    
    colorSwatches.forEach(swatch => {
      swatch.addEventListener('click', () => {
        const color = swatch.dataset.color;
        this.selectColor(color);
      });
    });
  }
  
  selectColor(color) {
    this.selectedColor = color;
    
    // Update UI
    const colorSwatches = this.shadowRoot.querySelectorAll('.color-swatch');
    colorSwatches.forEach(swatch => {
      if (swatch.dataset.color === color) {
        swatch.classList.add('active');
      } else {
        swatch.classList.remove('active');
      }
    });
    
    this.updateSelectedColorDisplay();
    
    // Dispatch event
    this.dispatchEvent(new CustomEvent('color-change', { detail: { color } }));
  }
  
  updateSelectedColorDisplay() {
    const selectedColorSpan = this.shadowRoot.getElementById('selected-color');
    if (selectedColorSpan) {
      selectedColorSpan.textContent = this.selectedColor;
    }
  }
  
  // Public method to get selected color
  getSelectedColor() {
    return this.selectedColor;
  }
  
  // Public method to set selected color
  setSelectedColor(color) {
    this.selectColor(color);
  }
}

customElements.define('color-selector-v2', ColorSelectorV2);